import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the search fields to find licenses by <strong>name</strong>, <strong>ID</strong>, or other attributes. Results display in a filterable table." id="use_the_search_fields_to_find_licenses_b.2a59a523" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Licenses" id="searching_licenses.7f04669c" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click a license to view its full details, including <strong>included content</strong>, <strong>pricing</strong>, and <strong>availability status</strong>." id="click_a_license_to_view_its_full_details.57cd3ba5" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="License Details" id="license_details.8bfaf889" />
        }
    ],
    title: <FormattedMessage defaultMessage="Licenses" id="licenses.11b1c36a" />
};
